<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal"
            :title="`${element.section_display_order}.${element.DisplayOrder} - ${element.ElementText}`"
            size="lg"
            :ok-title="`Save Result ${element.section_display_order}.${element.DisplayOrder}`"
            ok-variant="success"
            :ok-disabled="saving"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            ref="resultModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
                <div class="row mb-2">
                    <label :class="{ 'col-lg-2 col-md-3 col-form-label text-md-right': true, 'text-danger': errors.Comment }">Comment:</label>
                    <div class="col-md-8">
                        <textarea rows="2" placeholder="Enter Comment" v-model="result.Comment" :class="{'is-invalid': errors.Comment, 'form-control': true}"/>

                        <span v-if="errors.Comment" class="text-danger">
                            <span v-for="error in errors.Comment">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="row mb-2" v-if="false">
                    <div class="col-lg-2 text-lg-right">
                        Positive Findings:
                    </div>
                    <div class="col-lg-6 col-md-4 col-12">
                        <b-form-input type="number" step="1" v-model="result.total_positive_findings"
                            size="sm"
                            placeholder="Enter Total Positive Findings for this Item. Default = 1" />
                    </div>
                </div>
                <div class="row mb-2" v-if="false">
                    <div class="col-lg-2 text-lg-right">
                        Negative Findings:
                    </div>
                    <div class="col-lg-6 col-md-4 col-12">
                        <b-form-input type="number" step="1" v-model="result.total_positive_findings"
                            size="sm"
                            placeholder="Enter Total Positive Findings for this Item. Default = 0 for Compliant, 1 for Non-Compliant" />
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-lg-2 col-md-3 col-form-label text-md-right': true, 'text-danger': errors.file }">Files:</label>
                    <div class="col-md-8">
                        <vue2-dropzone ref="inspResultFiles"
                            id="insp-result-files"
                            :options="dropzoneOptions"
                            :useCustomSlot="true"
                            @vdropzone-success="fileUploaded"
                            @vdropzone-queue-complete="uploadComplete"
                            @vdropzone-sending="uploadInProgress"
                            style="border: 2px dashed #e5e5e5;">
                            <div class="dropzone-custom-content">
                                <h5 class="dropzone-custom-title">
                                    <i class="fa fa-plus-circle text-success"></i> Drag and Drop File(s) to Upload. Click to Select Files.
                                </h5>
                                <div class="subtitle">Once the file has been uploaded, you can add a note or caption to it.</div>
                            </div>
                        </vue2-dropzone>

                        <div class="mt-2" v-if="upload_in_progress">
                            <i class="fa fa-spin fa-spinner"></i> File(s) Are Uploading. Please Do Not Close this Pop Up.
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col-lg-10 offset-lg-1">
                        <file-list :files="(result.files ? result.files : [])" :editMode="true" :displayType="'list2.0'" />
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            InspectionId: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                upload_in_progress: false,
                errors: {},
                files: [],
                element: {},
                result: {}
            }
        },

        computed: {
            dropzoneOptions(){
                //SEtup
                var url = '/api/v1/files/upload?asset_type=InspectionResult&asset_id=' + this.result.InspectionResultId;

                //Send it
                return {
                    url: url,
                    //thumbnailWidth: 100,
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem('app_token')
                    }
                }
            },
        },

        methods: {

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }

                //Call hidden
                this.handleHidden(bvEvt);
            },

            handleHidden(bvEvt){
                //Reset the values
                this.result = {};
                this.errors = {};
                this.files = [];
            },

            handleOk(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveResult();
            },

            showModal(){
                //Show it
                this.openModal = true;
            },

            setElement(element){
                //Set the Element
                this.element = JSON.parse(JSON.stringify(element));
            },

            setModel(result){
                //Set the Result
                this.result = JSON.parse(JSON.stringify(result));

                //Turn off loading
                this.loading = false;
            },

            saveResult(){
                //Helper
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post(`inspections/result/${this.InspectionId}`, this.result)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Result Saved');

                    //Emit
                    this.$emit('resultSaved', response.data);

                    //Close the modal
                    this.$refs.resultModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                    else
                    {
                        console.log(error);
                    }
                })
                .then(() => {
                    //Show loading
                    this.saving = false;
                });
            },

            uploadInProgress(file, xhr, formData){
                //We just want to show the helper
                this.upload_in_progress = true;
            },

            fileUploaded(file, response){
                //Make Sure We Instantiated the Files
                if(typeof this.result.files == 'undefined')
                {
                    this.result.files = [];
                }

                //Push onto the stack
                this.result.files.push(response);

                //Remove the file?
                this.$refs.inspResultFiles.removeFile(file);
            },

            uploadComplete(){
                //Alert the user
                this.$toastr.success('File(s) Uploaded');

                //We just want to show the helper
                this.upload_in_progress = false;
            },
        },

        mounted() {
            //Set the height
            //this.$refs.resultModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            // this.getFormResources();
        }
    }
</script>